
<section class="ribbon-fixed">
  @if (systemMessageService.showRibbon && systemMessageService.selectedRibbon) {
    <div class="preventClick">
      
    </div>
  }
  @if (systemMessageService.showRibbon && systemMessageService.selectedRibbon) {
    <article #box class="alert in alert-dismissible " [ngClass]="['alert-' + systemMessageService.selectedRibbon.value]">
      <div class="ribbon-content"  >
        <strong>{{ systemMessageService.ribbonTitle | translate}}: </strong>
        <p>{{ systemMessageService.ribbonMessage | translate}}</p>
        <div class="ribbon-close" (click)="systemMessageService.closeRibbon()" aria-label="close" title="close">&times;</div>
      </div>
    </article>
  }
</section>
